import styled from 'styled-components';

export const NavToTopContainer = styled.div`
	height: 44px;
	position: fixed;
	right: 0;
	width: 44px;
	z-index: 1;
`;
